import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'

export class DetallesSiloDialogView extends Component {
  render () {
    const { silo } = this.props
    return (
      <div>
        <Row>
          <Col md={10}>
            <h2>Estado del silo {silo.nombreCorto}</h2>
          </Col>
          <Col md={2}>
            <svg width='45' height='45'>
              {silo.tipo === 'ENTRSILO'
                ? <rect
                  transform='rotate(45,20,20)'
                  x='9'
                  y='7'
                  width='30'
                  height='30'
                  opacity='1'
                  style={{ fill: '#' + (silo.color ? silo.color.trim().toLowerCase() : '757575') }}
                />
                : <circle cx='22' cy='22' r='20' style={{ fill: '#' + (silo.color ? silo.color.trim().toLowerCase() : '757575') }} />
              }
            </svg>
          </Col>
        </Row>
        <Row>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Linea: </span>{silo.linea ? silo.linea.trim() : 'Sin definir'}</Col>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Sector: </span>{silo.sector ? silo.sector.trim() : 'Sin definir'}</Col>
        </Row>
        <Row>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Cereal: </span>{silo.cereal ? silo.cereal : 'Sin definir'}</Col>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Variedad: </span>{silo.cereal ? silo.cereal : 'Sin definir'}</Col>
        </Row>
        <Row>
          <Col md={6}>
            <span style={{ fontWeight: 'bold', fontSize: 'large' }}>Estado:{' '}</span>
            {silo.estado === 'V'
              ? 'Vacio'
              : silo.estado === 'U'
                ? 'En uso'
                : silo.estado === 'L'
                  ? 'Lleno'
                  : silo.estado === 'D'
                    ? 'Deshabilitado'
                    : 'Sin definir'}
          </Col>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Vejez: </span>{silo.vejezSilo ? silo.vejezSilo : 'Sin definir'}</Col>
        </Row>
        <Row>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Metros de vacio: </span>{silo.metrosDeVacio ? silo.metrosDeVacio : 'Sin definir'}</Col>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Neto total base trigo: </span>{silo.netoTotalBaseTrigo ? silo.netoTotalBaseTrigo : 'Sin definir'}</Col>
        </Row>
        <Row>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Nucleo: </span>{silo.nucleo ? silo.nucleo.trim() : 'Sin definir'}</Col>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Peso neto: </span>{silo.pesoNeto ? silo.pesoNeto : 'Sin definir'}</Col>
        </Row>
        <Row>
          <Col md={6}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Ph: </span>{silo.ph ? silo.ph : 'Sin definir'}</Col>
        </Row>
        <br />
        <Row>
          <Col md={12}><span style={{ fontWeight: 'bold', fontSize: 'large' }}>Etiqueta: </span>{silo.etiqueta ? silo.etiqueta.trim() : 'Sin definir'}</Col>
        </Row>
      </div>
    )
  }
}
